// Single source of truth for the fonts (font families) used in the admin app.
// Font sizes and weights are not managed here; they stay in the components.
//
// fontFamilies.primary is the app font. Each entry below is a named font role
// (<Module><Element>Font; roles shared by 3+ modules are General<Element>Font)
// that points at a family, so a role can be switched on its own later.
//
// Usage:
//   SCSS / CSS / styled-components:  font-family: var(--FinanceDrawerSubtitleFont-family);
//   JS style objects / MUI sx:       fontFamily: fontConfig.FinanceDrawerSubtitleFont.family
//
// applyFontConfig() (called once in src/index.js) turns every entry into a CSS
// variable on :root.

export const fontFamilies = {
  primary: "Roboto, Helvetica, Arial, sans-serif",
  monospace: "monospace",
  inherit: "inherit",
};

export const fontConfig = {
  // General — shared by the same role in 3+ modules
  GeneralAddParticipantModalButtonFont: { family: fontFamilies.primary },
  GeneralAddParticipantModalCheckboxLabelFont: { family: fontFamilies.primary },
  GeneralAddParticipantModalContentLabelFont: { family: fontFamilies.primary },
  GeneralAddParticipantModalTitleFont: { family: fontFamilies.primary },
  GeneralAvatarsContainerFont: { family: fontFamilies.primary },
  GeneralBatchDolorFont: { family: fontFamilies.primary },
  GeneralBatchNameTitleFont: { family: fontFamilies.primary },
  GeneralBodyFont: { family: fontFamilies.primary },
  GeneralBtnsSectionButtonFont: { family: fontFamilies.primary },
  GeneralChargeTotalFont: { family: fontFamilies.primary },
  GeneralChargeTypeSpanFont: { family: fontFamilies.primary },
  GeneralClassBodyCellFont: { family: fontFamilies.primary },
  GeneralClassDrawerFont: { family: fontFamilies.primary },
  GeneralClassHeaderCellFont: { family: fontFamilies.primary },
  GeneralClassInfoTitleH3Font: { family: fontFamilies.primary },
  GeneralClassInfoTitlePFont: { family: fontFamilies.primary },
  GeneralClassLedgersMenuBtnFont: { family: fontFamilies.primary },
  GeneralClassStepsActiveFont: { family: fontFamilies.primary },
  GeneralClassStepsFont: { family: fontFamilies.primary },
  GeneralClassTabsFont: { family: fontFamilies.primary },
  GeneralClassTabsInactiveFont: { family: fontFamilies.primary },
  GeneralClassUploadImageFont: { family: fontFamilies.primary },
  GeneralCostInfoContainerFont: { family: fontFamilies.primary },
  GeneralCreateNewAccountAddFont: { family: fontFamilies.primary },
  GeneralCurrentClassTableContainerFont: { family: fontFamilies.primary },
  GeneralDataGridColumnHeaderTitleFont: { family: fontFamilies.primary },
  GeneralDeceasedModalContainerFont: { family: fontFamilies.primary },
  GeneralDonationTabAssignFont: { family: fontFamilies.primary },
  GeneralDrawerDescriptionH3Font: { family: fontFamilies.primary },
  GeneralDrawerDescriptionPFont: { family: fontFamilies.primary },
  GeneralEventTagFont: { family: fontFamilies.primary },
  GeneralFilterTabFont: { family: fontFamilies.primary },
  GeneralFinanceTableRowFont: { family: fontFamilies.primary },
  GeneralFormControlSolidFont: { family: fontFamilies.primary },
  GeneralFormTemplateNameFont: { family: fontFamilies.primary },
  GeneralInfoEmailFont: { family: fontFamilies.primary },
  GeneralInputFieldFont: { family: fontFamilies.primary },
  GeneralLabelFieldFont: { family: fontFamilies.primary },
  GeneralLeftContentInfoTitleH2Font: { family: fontFamilies.primary },
  GeneralLeftContentInfoTitlePFont: { family: fontFamilies.primary },
  GeneralLetterBodyHeaderH3Font: { family: fontFamilies.primary },
  GeneralLetterBtnsFont: { family: fontFamilies.primary },
  GeneralLetterConclusionFont: { family: fontFamilies.primary },
  GeneralLetterConclusionH3Font: { family: fontFamilies.primary },
  GeneralLetterConclusionH5Font: { family: fontFamilies.primary },
  GeneralLetterContentTitleH2Font: { family: fontFamilies.primary },
  GeneralLinkGoToTemlateFont: { family: fontFamilies.primary },
  GeneralMemberInfoDateLableFont: { family: fontFamilies.primary },
  GeneralMemberNameUpto460Font: { family: fontFamilies.primary },
  GeneralMournerInfoFont: { family: fontFamilies.primary },
  GeneralNewBatchChargeHeaderFont: { family: fontFamilies.primary },
  GeneralNonMemberAllowingFont: { family: fontFamilies.primary },
  GeneralNonRecipientsListTextFont: { family: fontFamilies.primary },
  GeneralNonRecipientsTitleH3Font: { family: fontFamilies.primary },
  GeneralOnHoldFont: { family: fontFamilies.primary },
  GeneralOptionalTypeAddBtnFont: { family: fontFamilies.primary },
  GeneralParticipantDrawerContainerHeaderFont: { family: fontFamilies.primary },
  GeneralParticipantMemberNameFont: { family: fontFamilies.primary },
  GeneralParticipantMemberNumberFont: { family: fontFamilies.primary },
  GeneralParticipantMenuItemNameFont: { family: fontFamilies.primary },
  GeneralParticipantNameTagFont: { family: fontFamilies.primary },
  GeneralPaymentInformationTotalFont: { family: fontFamilies.primary },
  GeneralPaymentTypeSelectFont: { family: fontFamilies.primary },
  GeneralPdfContentBodyFont: { family: fontFamilies.primary },
  GeneralPdfContentTitleFont: { family: fontFamilies.primary },
  GeneralPlusIconFont: { family: fontFamilies.monospace },
  GeneralPriceSectionFont: { family: fontFamilies.primary },
  GeneralPriceSectionSubtotalFont: { family: fontFamilies.primary },
  GeneralReactFormBuilderFont: { family: fontFamilies.primary },
  GeneralRecipientsListTextFont: { family: fontFamilies.primary },
  GeneralRecipientsTitleH3Font: { family: fontFamilies.primary },
  GeneralRegistrationStatusApprovedFont: { family: fontFamilies.primary },
  GeneralRegistrationStatusPendingFont: { family: fontFamilies.primary },
  GeneralReviewRowDivFont: { family: fontFamilies.primary },
  GeneralRightSectoinFont: { family: fontFamilies.primary },
  GeneralSelectFieldFont: { family: fontFamilies.primary },
  GeneralSelectionActiveValueNameFont: { family: fontFamilies.primary },
  GeneralSelectionActiveValueNumberFont: { family: fontFamilies.primary },
  GeneralSelectionInputFont: { family: fontFamilies.primary },
  GeneralStepLabelFont: { family: fontFamilies.primary },
  GeneralSuccessHeaderH3Font: { family: fontFamilies.primary },
  GeneralSuccessHeaderPFont: { family: fontFamilies.primary },
  GeneralSuccessSummaryH3Font: { family: fontFamilies.primary },
  GeneralSuccessSummaryReminderFont: { family: fontFamilies.primary },
  GeneralTableCellBodyFont: { family: fontFamilies.primary },
  GeneralTableCellHeadFont: { family: fontFamilies.primary },
  GeneralTableCellRootFont: { family: fontFamilies.primary },
  GeneralTotalAmountFont: { family: fontFamilies.primary },
  GeneralTransactionAccountNameFont: { family: fontFamilies.primary },
  GeneralTransactionPaymentStatusFont: { family: fontFamilies.primary },
  GeneralTransactionStatusFont: { family: fontFamilies.primary },

  // AddTags
  AddTagsEventTagsContainerFont: { family: fontFamilies.primary },
  AddTagsEventTagsContainerInactiveFont: { family: fontFamilies.primary },
  AddTagsTextFont: { family: fontFamilies.primary },
  AddTagsTotalAmountFont: { family: fontFamilies.primary },

  // App
  AppApplyCreateAccountFont: { family: fontFamilies.primary },
  AppCashNonExpandedFont: { family: fontFamilies.primary },

  // BulkTagging
  BulkTaggingAddNewTagContainerFont: { family: fontFamilies.primary },
  BulkTaggingAddTagsTextFont: { family: fontFamilies.primary },
  BulkTaggingCloseTagModaleFont: { family: fontFamilies.primary },
  BulkTaggingInputPlaceholderFont: { family: fontFamilies.primary },
  BulkTaggingOrgTagsTagFont: { family: fontFamilies.primary },
  BulkTaggingSelectedTagsTagFont: { family: fontFamilies.primary },

  // ClassPopOver
  ClassPopOverActionPopOverFont: { family: fontFamilies.primary },

  // Communication
  CommunicationAudienceParticipantsTableMetaFont: { family: fontFamilies.primary },
  CommunicationAudienceSummaryCommunicationsTitleFont: { family: fontFamilies.primary },
  CommunicationButtonItemFont: { family: fontFamilies.primary },
  CommunicationCreatedAutomationDoneTextFont: { family: fontFamilies.primary },
  CommunicationCreatedCampaignDoneTextFont: { family: fontFamilies.primary },
  CommunicationMessegeFont: { family: fontFamilies.primary },
  CommunicationPushLinkInputFont: { family: fontFamilies.primary },
  CommunicationSearchTableContainerTableTdFont: { family: fontFamilies.primary },
  CommunicationSearchTableContainerTableThFont: { family: fontFamilies.primary },
  CommunicationTagFont: { family: fontFamilies.primary },
  CommunicationTagsFont: { family: fontFamilies.primary },
  CommunicationTemplatesTextFont: { family: fontFamilies.primary },
  CommunicationTitleFont: { family: fontFamilies.primary },

  // CommunicationPopOver
  CommunicationPopOverActionPopOverFont: { family: fontFamilies.primary },

  // Components
  ComponentsDataTableFont: { family: fontFamilies.primary },

  // DatePicker
  DatePickerLabelStyleFont: { family: fontFamilies.primary },

  // Dialog
  DialogAlertDialogButtonFont: { family: fontFamilies.primary },
  DialogDialogContentTextFont: { family: fontFamilies.primary },
  DialogMainDialogTextFont: { family: fontFamilies.primary },

  // Donations
  DonationsBodyPFont: { family: fontFamilies.primary },
  DonationsLetterMainPFont: { family: fontFamilies.primary },
  DonationsThankYouLetterTextFont: { family: fontFamilies.primary },

  // Drawer
  DrawerTooltipFont: { family: fontFamilies.primary },

  // EasyCare
  EasyCareAddEventSwitchFont: { family: fontFamilies.primary },
  EasyCareAddNewReportSpanFont: { family: fontFamilies.primary },
  EasyCareAddUserBtnFont: { family: fontFamilies.primary },
  EasyCareAdminRoleFont: { family: fontFamilies.primary },
  EasyCareAssignSubHeadingFont: { family: fontFamilies.primary },
  EasyCareAssignSuccessfulHFont: { family: fontFamilies.primary },
  EasyCareAssignSuccessfulPFont: { family: fontFamilies.primary },
  EasyCareAssignSuccessfullHFont: { family: fontFamilies.primary },
  EasyCareAssignSuccessfullPFont: { family: fontFamilies.primary },
  EasyCareCardContentNumberFont: { family: fontFamilies.primary },
  EasyCareCardHFont: { family: fontFamilies.primary },
  EasyCareCloseBtnFont: { family: fontFamilies.primary },
  EasyCareDisabledRoleFont: { family: fontFamilies.primary },
  EasyCareEventSuccessfulHFont: { family: fontFamilies.primary },
  EasyCareEventSuccessfulPFont: { family: fontFamilies.primary },
  EasyCareEventTaskBoxStatusFont: { family: fontFamilies.primary },
  EasyCareEventTaskBoxTitleFont: { family: fontFamilies.primary },
  EasyCareFeedDesFont: { family: fontFamilies.primary },
  EasyCareFeedTitleFont: { family: fontFamilies.primary },
  EasyCareHeaderCellFont: { family: fontFamilies.primary },
  EasyCareMembersSpanFont: { family: fontFamilies.primary },
  EasyCareMenuTaskMenuItemRootFont: { family: fontFamilies.primary },
  EasyCareNewEventHeadingFont: { family: fontFamilies.primary },
  EasyCareSingleGroupNameSpanFont: { family: fontFamilies.primary },
  EasyCareStyledFormControlLabelFont: { family: fontFamilies.primary },
  EasyCareTableBodyCellFont: { family: fontFamilies.primary },
  EasyCareTaskDesFont: { family: fontFamilies.primary },
  EasyCareTaskTitleFont: { family: fontFamilies.primary },
  EasyCareTextAreaMessageFont: { family: fontFamilies.primary },
  EasyCareTitleNameGroupFont: { family: fontFamilies.primary },
  EasyCareTriggerContentSpanFont: { family: fontFamilies.primary },
  EasyCareUserTableContainerFont: { family: fontFamilies.primary },
  EasyCareUserTableHeaderFont: { family: fontFamilies.primary },

  // Editor
  EditorEmailEditorFont: { family: fontFamilies.primary },

  // Events
  EventsBulkCellHeaderFont: { family: fontFamilies.primary },
  EventsCostInfoTextFont: { family: fontFamilies.primary },
  EventsCurrentEventsTextFont: { family: fontFamilies.primary },
  EventsDescriptionPFont: { family: fontFamilies.primary },
  EventsDescriptionSpanFont: { family: fontFamilies.primary },
  EventsDrawerEventDetailsAddressLabelFont: { family: fontFamilies.primary },
  EventsDrawerEventDetailsAddressValueFont: { family: fontFamilies.primary },
  EventsDrawerEventDetailsDateItemFont: { family: fontFamilies.primary },
  EventsDrawerEventDetailsDateMoreFont: { family: fontFamilies.primary },
  EventsEventDetailsTextFont: { family: fontFamilies.primary },
  EventsEventDrawerTextFont: { family: fontFamilies.primary },
  EventsEventInfoTextFont: { family: fontFamilies.primary },
  EventsFindMyCityFont: { family: fontFamilies.primary },
  EventsFormWrapperInfoTitleH2Font: { family: fontFamilies.primary },
  EventsFormWrapperInfoTitlePFont: { family: fontFamilies.primary },
  EventsInputFieldWithCheckboxFont: { family: fontFamilies.primary },
  EventsInputTitleFont: { family: fontFamilies.primary },
  EventsInternalDrawerTextFont: { family: fontFamilies.primary },
  EventsParticipantDetailsTableBodyTextFont: { family: fontFamilies.primary },
  EventsPriceDiscountTextFont: { family: fontFamilies.primary },
  EventsTableCellFont: { family: fontFamilies.primary },
  EventsTitleFont: { family: fontFamilies.primary },
  EventsTotalPFont: { family: fontFamilies.primary },
  EventsTotalSpanFont: { family: fontFamilies.primary },
  EventsTtlFont: { family: fontFamilies.primary },
  EventsWorningSpanFont: { family: fontFamilies.primary },
  EventsWrapperFont: { family: fontFamilies.primary },

  // ExternalDonation
  ExternalDonationAmountCouseInputFont: { family: fontFamilies.primary },
  ExternalDonationAmountCousePlaceholderIconFont: { family: fontFamilies.primary },
  ExternalDonationDonationInputFont: { family: fontFamilies.primary },

  // Filter
  FilterItemFont: { family: fontFamilies.primary },

  // FilterButton
  FilterButtonFilterTextFont: { family: fontFamilies.primary },

  // Finance
  FinanceACHText2Font: { family: fontFamilies.primary },
  FinanceACHTextFont: { family: fontFamilies.primary },
  FinanceAccordionSummaryContentLabelFont: { family: fontFamilies.primary },
  FinanceAddNewPaymentInfoAddFont: { family: fontFamilies.primary },
  FinanceAddNewPaymentInfoFont: { family: fontFamilies.monospace },
  FinanceBillingTableTitleNameFont: { family: fontFamilies.primary },
  FinanceBulkCellHeaderFont: { family: fontFamilies.primary },
  FinanceClassLedgersMenuBtnFont: { family: fontFamilies.primary },
  FinanceCreditBalanceFont: { family: fontFamilies.primary },
  FinanceCreditOnAccountTitleFont: { family: fontFamilies.primary },
  FinanceDepositsRadioTabsTextFont: { family: fontFamilies.primary },
  FinanceDonorDescriptionAlignFont: { family: fontFamilies.primary },
  FinanceDonorDescriptionparaFont: { family: fontFamilies.primary },
  FinanceDownloadBulkFont: { family: fontFamilies.primary },
  FinanceDrawerFont: { family: fontFamilies.primary },
  FinanceDrawerSubtitleFont: { family: fontFamilies.primary },
  FinanceDrawerTitleFont: { family: fontFamilies.primary },
  FinanceFormGroupLabelFont: { family: fontFamilies.primary },
  FinanceLabelFont: { family: fontFamilies.primary },
  FinanceNewChargeHeaderFont: { family: fontFamilies.primary },
  FinanceNewTaxStatementHeadingFont: { family: fontFamilies.primary },
  FinancePaymentDetailRowLabelFont: { family: fontFamilies.primary },
  FinancePaymentExceedsErrorFont: { family: fontFamilies.primary },
  FinancePaymentInfoFeeLabelFont: { family: fontFamilies.primary },
  FinancePaymentInfoFeeValueFont: { family: fontFamilies.primary },
  FinancePaymentInfoTotalDueFont: { family: fontFamilies.primary },
  FinancePaymentInfoTotalLabelFont: { family: fontFamilies.primary },
  FinancePaymentInformationTextFont: { family: fontFamilies.primary },
  FinancePaymentMethodsTitleFont: { family: fontFamilies.primary },
  FinancePaymentPlansTextFont: { family: fontFamilies.primary },
  FinancePmMethodCardFont: { family: fontFamilies.primary },
  FinancePmRecentlyUsedLabelFont: { family: fontFamilies.primary },
  FinancePpChargeLinkFont: { family: fontFamilies.monospace },
  FinancePrimaryButtonFont: { family: fontFamilies.primary },
  FinanceReviewBottomCardLabelFont: { family: fontFamilies.primary },
  FinanceReviewBottomCardTextareaFont: { family: fontFamilies.primary },
  FinanceReviewCardTitleFont: { family: fontFamilies.primary },
  FinanceReviewCheckboxRowLabelFont: { family: fontFamilies.primary },
  FinanceReviewLabelFont: { family: fontFamilies.primary },
  FinanceReviewMethodAmountFont: { family: fontFamilies.primary },
  FinanceReviewMethodNameFont: { family: fontFamilies.primary },
  FinanceReviewMethodsTitleFont: { family: fontFamilies.primary },
  FinanceReviewTextFont: { family: fontFamilies.primary },
  FinanceReviewValueFont: { family: fontFamilies.primary },
  FinanceSendLetterBtnFont: { family: fontFamilies.primary },
  FinanceStepLabelFont: { family: fontFamilies.primary },
  FinanceSubFont: { family: fontFamilies.primary },
  FinanceTableRowFont: { family: fontFamilies.primary },
  FinanceTempleteWrapprFont: { family: fontFamilies.primary },
  FinanceTextAreaMessageFont: { family: fontFamilies.primary },
  FinanceTitleGroupFont: { family: fontFamilies.primary },
  FinanceTitleTotalSpaceFont: { family: fontFamilies.primary },
  FinanceTotalPaymentAmountFont: { family: fontFamilies.primary },
  FinanceTransactionsTableTextFont: { family: fontFamilies.primary },

  // FinancePopover
  FinancePopoverTextFont: { family: fontFamilies.primary },

  // FormManage
  FormManageCheckboxFieldTitleStylesFont: { family: fontFamilies.primary },
  FormManageClassLedgersMenuBtnFont: { family: fontFamilies.primary },
  FormManageCommonInputFieldTitleStyleFont: { family: fontFamilies.primary },
  FormManageDateRangeTitleFont: { family: fontFamilies.primary },
  FormManageMyCheckboxFont: { family: fontFamilies.primary },
  FormManageRadioTextFont: { family: fontFamilies.primary },
  FormManageRsPickerToggleValueFont: { family: fontFamilies.primary },
  FormManageTextEditorTitleStyleFont: { family: fontFamilies.primary },
  FormManageToggleTextFont: { family: fontFamilies.primary },

  // Forms
  FormsClassStepsActiveFont: { family: fontFamilies.primary },
  FormsClassStepsFont: { family: fontFamilies.primary },
  FormsColFont: { family: fontFamilies.primary },
  FormsCostInfoContainerFont: { family: fontFamilies.primary },
  FormsCostInfoTextFont: { family: fontFamilies.primary },
  FormsDescriptionPFont: { family: fontFamilies.primary },
  FormsDescriptionSpanFont: { family: fontFamilies.primary },
  FormsDiscountDisclaimerFont: { family: fontFamilies.primary },
  FormsDrawerEventDetailsAddressLabelFont: { family: fontFamilies.primary },
  FormsDrawerEventDetailsAddressValueFont: { family: fontFamilies.primary },
  FormsDrawerEventDetailsDateItemFont: { family: fontFamilies.primary },
  FormsFormInfoTextFont: { family: fontFamilies.primary },
  FormsFormWrapperInfoTitleH2Font: { family: fontFamilies.primary },
  FormsFormWrapperInfoTitlePFont: { family: fontFamilies.primary },
  FormsInputFieldWithCheckboxFont: { family: fontFamilies.primary },
  FormsInputTitleFont: { family: fontFamilies.primary },
  FormsMemberContainerInfoTitleH2Font: { family: fontFamilies.primary },
  FormsMemberContainerInfoTitlePFont: { family: fontFamilies.primary },
  FormsTitleFont: { family: fontFamilies.primary },
  FormsTotalPFont: { family: fontFamilies.primary },
  FormsTotalSpanFont: { family: fontFamilies.primary },
  FormsTtlFont: { family: fontFamilies.primary },
  FormsWorningSpanFont: { family: fontFamilies.primary },
  FormsWrapperFont: { family: fontFamilies.primary },

  // Fundraising
  FundraisingAmountChipFont: { family: fontFamilies.primary },
  FundraisingAnalyticsTextFont: { family: fontFamilies.primary },
  FundraisingBackBtnSpanFont: { family: fontFamilies.primary },
  FundraisingBadgeFont: { family: fontFamilies.primary },
  FundraisingCampaignFormTextFont: { family: fontFamilies.primary },
  FundraisingCampaignWysiwygFont: { family: fontFamilies.primary },
  FundraisingCfPreviewBannerChipFont: { family: fontFamilies.primary },
  FundraisingCfPreviewChipFont: { family: fontFamilies.primary },
  FundraisingCfPreviewColorChipFont: { family: fontFamilies.primary },
  FundraisingCfPreviewDescFont: { family: fontFamilies.primary },
  FundraisingCfPreviewDonateFont: { family: fontFamilies.primary },
  FundraisingCfPreviewEditBtnFont: { family: fontFamilies.primary },
  FundraisingCfPreviewEndDateFont: { family: fontFamilies.primary },
  FundraisingCfPreviewGoalTextFont: { family: fontFamilies.primary },
  FundraisingCfPreviewHeroChangeFont: { family: fontFamilies.primary },
  FundraisingCfPreviewHeroEmptyFont: { family: fontFamilies.primary },
  FundraisingCfPreviewHintFont: { family: fontFamilies.primary },
  FundraisingCfPreviewImageChipFont: { family: fontFamilies.primary },
  FundraisingCfPreviewLogoAddFont: { family: fontFamilies.primary },
  FundraisingCfPreviewLogoEmptyFont: { family: fontFamilies.primary },
  FundraisingCfPreviewSectionHeadFont: { family: fontFamilies.primary },
  FundraisingCfPreviewStatLblFont: { family: fontFamilies.primary },
  FundraisingCfPreviewStatValFont: { family: fontFamilies.primary },
  FundraisingCfPreviewSubtitleFieldFont: { family: fontFamilies.primary },
  FundraisingCfPreviewTitleFieldFont: { family: fontFamilies.primary },
  FundraisingCfPreviewTitleTextFont: { family: fontFamilies.primary },
  FundraisingCfTabFont: { family: fontFamilies.primary },
  FundraisingChartFont: { family: fontFamilies.primary },
  FundraisingComposeTitleFont: { family: fontFamilies.primary },
  FundraisingDialogTitleFont: { family: fontFamilies.primary },
  FundraisingDonorRowFont: { family: fontFamilies.primary },
  FundraisingDonorsListTextFont: { family: fontFamilies.primary },
  FundraisingEmptyStateFont: { family: fontFamilies.primary },
  FundraisingFeedTitleFont: { family: fontFamilies.primary },
  FundraisingIconBtnFont: { family: fontFamilies.primary },
  FundraisingInputFont: { family: fontFamilies.primary },
  FundraisingListTextFont: { family: fontFamilies.primary },
  FundraisingMenuItemFont: { family: fontFamilies.primary },
  FundraisingPageTitleFont: { family: fontFamilies.primary },
  FundraisingProgressMetaFont: { family: fontFamilies.primary },
  FundraisingSectionLabelFont: { family: fontFamilies.primary },
  FundraisingSectionTitleFont: { family: fontFamilies.primary },
  FundraisingStatLabelFont: { family: fontFamilies.primary },
  FundraisingStatValueFont: { family: fontFamilies.primary },
  FundraisingStatusMsgFont: { family: fontFamilies.primary },
  FundraisingSummaryLabelFont: { family: fontFamilies.primary },
  FundraisingSummaryValueFont: { family: fontFamilies.primary },
  FundraisingSysTextFieldFont: { family: fontFamilies.primary },
  FundraisingTextFieldFont: { family: fontFamilies.primary },
  FundraisingUpdateBodyFont: { family: fontFamilies.primary },
  FundraisingUpdateMetaFont: { family: fontFamilies.primary },
  FundraisingUpdateTitleFont: { family: fontFamilies.primary },

  // HebrewDatePicker
  HebrewDatePickerLabelStyleFont: { family: fontFamilies.primary },
  HebrewDatePickerSelectedDateFont: { family: fontFamilies.primary },

  // InfoTooltip
  InfoTooltipTextFont: { family: fontFamilies.primary },

  // InputField
  InputFieldLabelFont: { family: fontFamilies.primary },

  // LabelField
  LabelFieldBodyFont: { family: fontFamilies.primary },

  // Layout
  LayoutAddNotifyTitleFont: { family: fontFamilies.primary },
  LayoutNotificationSettingsCloseBtnFont: { family: fontFamilies.primary },
  LayoutNotificationSettingsTextFont: { family: fontFamilies.primary },

  // MainModal
  MainModalButtonFont: { family: fontFamilies.primary },

  // MemberCard
  MemberCardIdNumberFont: { family: fontFamilies.primary },
  MemberCardMemberNameFont: { family: fontFamilies.primary },

  // MemberDetails
  MemberDetailsAccountDetailsHeaderTextFont: { family: fontFamilies.primary },
  MemberDetailsAccountTypeFont: { family: fontFamilies.primary },
  MemberDetailsAccountTypesTagsFont: { family: fontFamilies.primary },
  MemberDetailsAddEventSwitchFont: { family: fontFamilies.primary },
  MemberDetailsAddNewTagContainerFont: { family: fontFamilies.primary },
  MemberDetailsAddTagFieldItemFont: { family: fontFamilies.primary },
  MemberDetailsAddTagFieldTextFont: { family: fontFamilies.primary },
  MemberDetailsAddTagFont: { family: fontFamilies.primary },
  MemberDetailsAddTagsTextFont: { family: fontFamilies.primary },
  MemberDetailsAssignSubHeadingFont: { family: fontFamilies.primary },
  MemberDetailsAssignSuccessfulHFont: { family: fontFamilies.primary },
  MemberDetailsAssignSuccessfulPFont: { family: fontFamilies.primary },
  MemberDetailsBillingTypeFont: { family: fontFamilies.primary },
  MemberDetailsCloseBtnFont: { family: fontFamilies.primary },
  MemberDetailsContactBtnFont: { family: fontFamilies.primary },
  MemberDetailsDeceasedTableListTextFont: { family: fontFamilies.primary },
  MemberDetailsDescriptionFont: { family: fontFamilies.primary },
  MemberDetailsDonorDescriptionAlignFont: { family: fontFamilies.primary },
  MemberDetailsDonorDescriptionparaFont: { family: fontFamilies.primary },
  MemberDetailsDrawerTitleFont: { family: fontFamilies.primary },
  MemberDetailsEventSuccessfulHFont: { family: fontFamilies.primary },
  MemberDetailsEventSuccessfulPFont: { family: fontFamilies.primary },
  MemberDetailsEventTaskBoxStatusFont: { family: fontFamilies.primary },
  MemberDetailsEventTaskBoxTitleFont: { family: fontFamilies.primary },
  MemberDetailsEventsTextFont: { family: fontFamilies.primary },
  MemberDetailsFeedDesFont: { family: fontFamilies.primary },
  MemberDetailsFeedTitleFont: { family: fontFamilies.primary },
  MemberDetailsFinanceDrawerFont: { family: fontFamilies.primary },
  MemberDetailsInputPlaceholderFont: { family: fontFamilies.primary },
  MemberDetailsLabelFont: { family: fontFamilies.primary },
  MemberDetailsLefContentDetailsNameFont: { family: fontFamilies.primary },
  MemberDetailsNewEventHeadingFont: { family: fontFamilies.primary },
  MemberDetailsOrgTagsTagFont: { family: fontFamilies.primary },
  MemberDetailsSectionTitleFont: { family: fontFamilies.primary },
  MemberDetailsSelectedTagsTagFont: { family: fontFamilies.primary },
  MemberDetailsSubTypeFont: { family: fontFamilies.primary },
  MemberDetailsTableCellFont: { family: fontFamilies.primary },
  MemberDetailsTagsTagFont: { family: fontFamilies.primary },
  MemberDetailsTitleFont: { family: fontFamilies.primary },
  MemberDetailsUpdateDesFont: { family: fontFamilies.primary },
  MemberDetailsUpdateTextFont: { family: fontFamilies.primary },
  MemberDetailsUserDetailsHeaderTextFont: { family: fontFamilies.primary },
  MemberDetailsUserIdFont: { family: fontFamilies.primary },
  MemberDetailsUserNameFont: { family: fontFamilies.primary },
  MemberDetailsUserTypeFont: { family: fontFamilies.primary },

  // Members
  MembersAccountHeaderNameFont: { family: fontFamilies.primary },
  MembersAddTagFieldItemFont: { family: fontFamilies.primary },
  MembersDataGridRootFont: { family: fontFamilies.primary },
  MembersFormInputFont: { family: fontFamilies.inherit },
  MembersIdContainerFont: { family: fontFamilies.primary },
  MembersLabelFont: { family: fontFamilies.primary },
  MembersMemberNameFont: { family: fontFamilies.primary },
  MembersMemberTablseTextFont: { family: fontFamilies.primary },
  MembersNoteFormInputFont: { family: fontFamilies.inherit },
  MembersNoteTagFont: { family: fontFamilies.primary },
  MembersOrderFieldsTaggingTagItemFont: { family: fontFamilies.primary },
  MembersSearchTableContainerTableTdFont: { family: fontFamilies.primary },
  MembersSearchTableContainerTableThFont: { family: fontFamilies.primary },
  MembersSelectMultiValueFont: { family: fontFamilies.primary },
  MembersWrapperMemberItemFont: { family: fontFamilies.primary },

  // MultiSelect
  MultiSelectButtonFont: { family: fontFamilies.primary },
  MultiSelectInputFieldPlaceholderFont: { family: fontFamilies.primary },
  MultiSelectLabelFont: { family: fontFamilies.primary },

  // NewButton
  NewButtonWrapperFont: { family: fontFamilies.primary },

  // NewDialog
  NewDialogContentPFont: { family: fontFamilies.primary },

  // OrganizationSettings
  OrganizationSettingsGoogleCalendarInputFont: { family: fontFamilies.primary },

  // ProTable
  ProTableDataGridRootFont: { family: fontFamilies.primary },

  // RadioButtons
  RadioButtonsStyledFormControlLabelFont: { family: fontFamilies.primary },

  // Report
  ReportAsOfSpanFont: { family: fontFamilies.primary },
  ReportCellFont: { family: fontFamilies.primary },
  ReportTitleContentH1Font: { family: fontFamilies.primary },

  // Reports
  ReportsBillingTableTitleNameFont: { family: fontFamilies.primary },
  ReportsReportTextFont: { family: fontFamilies.primary },
  ReportsSpanHeaderFont: { family: fontFamilies.primary },
  ReportsSpanNameReportFont: { family: fontFamilies.primary },
  ReportsSpanNameReportSpanFont: { family: fontFamilies.primary },
  ReportsSpanReportFont: { family: fontFamilies.primary },
  ReportsTableCellBodyTotalFont: { family: fontFamilies.primary },
  ReportsTotalBillingRowFont: { family: fontFamilies.primary },
  ReportsTotalBillingRowSpanFont: { family: fontFamilies.primary },
  ReportsTotalFont: { family: fontFamilies.primary },

  // School
  SchoolClassDrawerTextFont: { family: fontFamilies.primary },
  SchoolClassInfoTextFont: { family: fontFamilies.primary },
  SchoolFormWrapperInfoTitleH2Font: { family: fontFamilies.primary },
  SchoolFormWrapperInfoTitlePFont: { family: fontFamilies.primary },
  SchoolInternalDrawerTextFont: { family: fontFamilies.primary },

  // SearchAutoComplete
  SearchAutoCompleteSelectSearchFont: { family: fontFamilies.primary },
  SearchAutoCompleteSelectSearchInputFont: { family: fontFamilies.primary },
  SearchAutoCompleteSelectSearchOptionFont: { family: fontFamilies.primary },

  // SelectFields
  SelectFieldsDropdownTextFont: { family: fontFamilies.primary },

  // SendLetter
  SendLetterConfirmSaveTemplateModalTitleFont: { family: fontFamilies.primary },
  SendLetterInputFieldPrimaryFont: { family: fontFamilies.primary },
  SendLetterLetterContentHeaderTabsTabFont: { family: fontFamilies.primary },

  // Settings
  SettingsAddCheckboxFont: { family: fontFamilies.primary },
  SettingsAddUserBtnFont: { family: fontFamilies.primary },
  SettingsAddUserBtnUsersFont: { family: fontFamilies.primary },
  SettingsAddUserDrawerTextFont: { family: fontFamilies.primary },
  SettingsAdminRoleFont: { family: fontFamilies.primary },
  SettingsAvatarFont: { family: fontFamilies.primary },
  SettingsBreadcrumbLinkFont: { family: fontFamilies.primary },
  SettingsCameraIconFont: { family: fontFamilies.primary },
  SettingsCancelVacationBtnFont: { family: fontFamilies.primary },
  SettingsCheckboxChargeEditFont: { family: fontFamilies.primary },
  SettingsContactInfoFont: { family: fontFamilies.primary },
  SettingsCreateNewUserTextFont: { family: fontFamilies.primary },
  SettingsDetailCardPFont: { family: fontFamilies.primary },
  SettingsDisabledRoleFont: { family: fontFamilies.primary },
  SettingsDrawerHeaderActionsCancleFont: { family: fontFamilies.primary },
  SettingsDrawerHeaderTitleFont: { family: fontFamilies.primary },
  SettingsDrawerUserPermmistionsListFont: { family: fontFamilies.primary },
  SettingsDrawerUserPermmistionsListItemFont: { family: fontFamilies.primary },
  SettingsDrawerUserPermmistionsListItemsFont: { family: fontFamilies.primary },
  SettingsDrawerUserPermmistionsListShabbatFont: { family: fontFamilies.primary },
  SettingsDropdownOptionsTitleFont: { family: fontFamilies.primary },
  SettingsEmailDrawerBtnButtonFont: { family: fontFamilies.primary },
  SettingsFirstRowFont: { family: fontFamilies.primary },
  SettingsFormNameFont: { family: fontFamilies.primary },
  SettingsHeaderCellFont: { family: fontFamilies.primary },
  SettingsImgUserDrawerFont: { family: fontFamilies.primary },
  SettingsLeftMenuItemsFont: { family: fontFamilies.primary },
  SettingsLegderSubMenuFont: { family: fontFamilies.primary },
  SettingsPaymentGatewayTitleFont: { family: fontFamilies.primary },
  SettingsPaymentTypeCheckBoxFont: { family: fontFamilies.primary },
  SettingsPaymentsHeadingH2Font: { family: fontFamilies.primary },
  SettingsPopoverDrawerFont: { family: fontFamilies.primary },
  SettingsPopoverDrawerUserFont: { family: fontFamilies.primary },
  SettingsResetMobilePasswordHeaderFont: { family: fontFamilies.primary },
  SettingsSearchWrapperInputFont: { family: fontFamilies.primary },
  SettingsSettingHeadH2Font: { family: fontFamilies.primary },
  SettingsSettingTabsItemFont: { family: fontFamilies.primary },
  SettingsShabbatPFont: { family: fontFamilies.primary },
  SettingsTableBodyCellFont: { family: fontFamilies.primary },
  SettingsTitleHeadFont: { family: fontFamilies.primary },
  SettingsTreeItemLabelFont: { family: fontFamilies.primary },
  SettingsTypeCheckBoxFont: { family: fontFamilies.primary },
  SettingsUpdateUserDrawerTextFont: { family: fontFamilies.primary },
  SettingsUpdateUserHeaderFont: { family: fontFamilies.primary },
  SettingsUserDrawerContentFont: { family: fontFamilies.primary },
  SettingsUserDrawerTextFont: { family: fontFamilies.primary },
  SettingsUserHeaderActionFont: { family: fontFamilies.primary },
  SettingsUserPermmistionsListItemPFont: { family: fontFamilies.primary },
  SettingsUserTableContainerFont: { family: fontFamilies.primary },
  SettingsUserTableHeaderFont: { family: fontFamilies.primary },

  // SideMenuList
  SideMenuListItemFont: { family: fontFamilies.primary },

  // SuccessModal
  SuccessModalButtonFont: { family: fontFamilies.primary },
  SuccessModalDescriptionFont: { family: fontFamilies.primary },
  SuccessModalTitleFont: { family: fontFamilies.primary },

  // SwitchTabs
  SwitchTabsButtonItemFont: { family: fontFamilies.primary },

  // TreeList
  TreeListTreeItemLabelFont: { family: fontFamilies.primary },

  // Views
  ViewsAccountTextFont: { family: fontFamilies.primary },
  ViewsAuthFormTitleFont: { family: fontFamilies.primary },
  ViewsLoginBtnLinkFont: { family: fontFamilies.primary },
  ViewsPoweredTextFont: { family: fontFamilies.primary },
  ViewsSignupLinkFont: { family: fontFamilies.primary },

  // Yahrzeit
  YahrzeitDataGridCellFont: { family: fontFamilies.primary },
  YahrzeitDceacedNameFont: { family: fontFamilies.primary },
  YahrzeitIdContainerFont: { family: fontFamilies.primary },
  YahrzeitOutlinedInputRootFont: { family: fontFamilies.primary },
  YahrzeitSendLetterBtnFont: { family: fontFamilies.primary },
  YahrzeitSendStatusDateFont: { family: fontFamilies.primary },
  YahrzeitSendStatusValueFont: { family: fontFamilies.primary },
  YahrzeitSvgFiltersFont: { family: fontFamilies.primary },
  YahrzeitYahTotalFont: { family: fontFamilies.primary },
};

export const applyFontConfig = (root = document.documentElement) => {
  Object.entries(fontConfig).forEach(([name, font]) => {
    root.style.setProperty(`--${name}-family`, font.family);
  });
};
